import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { Form } from 'semantic-ui-react';
import { validateFormField, getFieldError } from './CheckboxField.utils';
import { FormFieldCheckboxPropType } from '../../../../../types/FormField.types';
import { DynamicFormContext } from '../../../context/DynamicFormContext';
function CheckboxField(_ref) {
  var field = _ref.field,
    value = _ref.value;
  var _useContext = useContext(DynamicFormContext),
    isFormDisabled = _useContext.isFormDisabled,
    onChange = _useContext.onChange,
    formErrors = _useContext.formErrors,
    displayErrors = _useContext.displayErrors,
    clearFieldError = _useContext.clearFieldError,
    setFormErrors = _useContext.setFormErrors;
  var label = field.label,
    name = field.name,
    required = field.required;
  function handleChange(e, _ref2) {
    var fieldName = _ref2.name,
      fieldValue = _ref2.checked;
    clearFieldError(name);
    onChange(e, {
      name: fieldName,
      checked: fieldValue
    });
    var error = validateFormField(field, fieldValue);
    if (error) {
      setFormErrors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), error);
      });
    }
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    disabled: isFormDisabled
  }, /*#__PURE__*/React.createElement(Form.Checkbox, {
    id: name,
    name: name,
    label: /*#__PURE__*/React.createElement("label", {
      htmlFor: name
    }, label),
    onChange: handleChange,
    checked: value,
    required: required,
    error: getFieldError(displayErrors, formErrors[name])
  }));
}
export default CheckboxField;